import { render } from "./FlutterPayment.vue?vue&type=template&id=79c33d8b"
import script from "./FlutterPayment.vue?vue&type=script&lang=js"
export * from "./FlutterPayment.vue?vue&type=script&lang=js"
script.render = render

export default script